import React from 'react';

interface TradeBadgeProps {
  trade: string;
  size?: 'sm' | 'md' | 'lg';
}

export const TradeBadge: React.FC<TradeBadgeProps> = ({ trade, size = 'md' }) => {
  const getTradeColor = (tradeName: string): string => {
    const tradeColors: Record<string, string> = {
      'Carpenter': 'bg-amber-100 text-amber-700 border-amber-200',
      'Electrician': 'bg-yellow-100 text-yellow-700 border-yellow-200',
      'Plumber': 'bg-blue-100 text-blue-700 border-blue-200',
      'HVAC': 'bg-cyan-100 text-cyan-700 border-cyan-200',
      'Mason': 'bg-stone-100 text-stone-700 border-stone-200',
      'Painter': 'bg-purple-100 text-purple-700 border-purple-200',
      'Roofer': 'bg-slate-100 text-slate-700 border-slate-200',
      'Welder': 'bg-orange-100 text-orange-700 border-orange-200',
      'Drywall': 'bg-gray-100 text-gray-700 border-gray-200',
      'Flooring': 'bg-rose-100 text-rose-700 border-rose-200',
      'Landscaper': 'bg-green-100 text-green-700 border-green-200',
      'General Labor': 'bg-indigo-100 text-indigo-700 border-indigo-200',
      'Concrete': 'bg-zinc-100 text-zinc-700 border-zinc-200',
      'Tile': 'bg-teal-100 text-teal-700 border-teal-200',
      'Framing': 'bg-amber-100 text-amber-700 border-amber-200',
      'Insulation': 'bg-sky-100 text-sky-700 border-sky-200',
      'Glazier': 'bg-cyan-100 text-cyan-700 border-cyan-200',
      'Ironworker': 'bg-neutral-100 text-neutral-700 border-neutral-200',
    };

    return tradeColors[tradeName] || 'bg-slate-100 text-slate-700 border-slate-200';
  };

  const sizeClasses = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-2.5 py-1 text-sm',
    lg: 'px-3 py-1.5 text-base',
  };

  return (
    <span
      className={`inline-flex items-center rounded-full font-medium border ${getTradeColor(trade)} ${sizeClasses[size]}`}
    >
      {trade}
    </span>
  );
};
